export const pdfLink = "https://app.mirzawaleed.com";